module.exports = __webpack_public_path__ + "img/snapchat_white.7bcb06fb.svg";